import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { TranslateModule } from '@ngx-translate/core';

interface Classification {
  id: string;
  score: number;
  justification: string;
  page?: number;
}

@Component({
  selector: 'app-classifications-view',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, TranslateModule],
  templateUrl: './classifications-view.component.html',
  styleUrls: ['./classifications-view.component.scss']
})
export class ClassificationsViewComponent {
  @Input() classifications: Classification[] = [];
  @Output() download = new EventEmitter<void>();
  @Output() classificationClick = new EventEmitter<Classification>();

  icons = { faDownload };

  getScoreColor(score: number): string {
    if (score >= 0.7) return 'var(--success-color, #4caf50)';
    if (score >= 0.3) return 'var(--warning-color, #ff9800)';
    return 'var(--text-tertiary, #888)';
  }

  formatScore(score: number): string {
    return (score * 100).toFixed(0) + '%';
  }

  onDownload(): void {
    this.download.emit();
  }

  onItemClick(item: Classification): void {
    if (item.page !== undefined) {
      this.classificationClick.emit(item);
    }
  }
}
